import { Fragment, type ComponentProps } from "react";

import { Link } from "@/components/link";
import type { ArtistEntry } from "@garimpa/lib/musicTypes";

export function ArtistLinks({
  appearance,
  artists,
  className,
}: {
  appearance?: ComponentProps<typeof Link>["appearance"];
  artists?: readonly ArtistEntry[] | null;
  className?: string;
}) {
  if (!artists?.length) return null;

  return artists.map((artist, index) => (
    <Fragment key={`${artist.id}-${artist.name}-${index}`}>
      <Link appearance={appearance} to={`/artist/${artist.id}`} className={className}>
        {artist.name}
      </Link>
      {artist.joinSeparator && <span>{artist.joinSeparator}</span>}
    </Fragment>
  ));
}
